import { useState } from "react";
import { useAuth } from "../App";
import { api, errMsg } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { toast } from "sonner";

export default function ForcePasswordReset() {
  const { user, setUser } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      setUser({ ...user, must_reset_password: false });
      toast.success("Password updated");
    } catch (err) {
      toast.error(errMsg(err));
    }
    setBusy(false);
  };

  return (
    <Dialog open>
      <DialogContent className="sm:max-w-md" data-testid="force-reset-dialog" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="font-display">Set a new password</DialogTitle>
          <DialogDescription>For security you must change your password before continuing.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <Input type="password" placeholder="Current (temporary) password" value={current} onChange={(e) => setCurrent(e.target.value)} required data-testid="force-reset-current" />
          <Input type="password" placeholder="New password (min 8 characters)" value={next} onChange={(e) => setNext(e.target.value)} required minLength={8} data-testid="force-reset-new" />
          <Button type="submit" disabled={busy} className="w-full sw-red hover:bg-red-700 text-white" data-testid="force-reset-submit">
            {busy ? "Saving…" : "Update password"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
